import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { OnboardingDataResponse } from "@src/types/onboardingDataResponse";

export const useOnboardingData = (
  organizationId: number,
  platform: number,
  locale: string,
  enabled: boolean,
  onboardingType: number,
  priceMode?: number
) => {
  return useQuery({
    queryKey: ["ONBOARDING_DATA", locale, onboardingType],
    cacheTime: 0,
    enabled,
    staleTime: 0,
    queryFn: () =>
      apiClient.get<OnboardingDataResponse[]>(Routes.ONBOARDING_DATA, {
        params: {
          organization_id: organizationId,
          platform: platform,
          locale: locale,
          onboarding_type: onboardingType,
          price_mode: priceMode,
        },
        headers: {
          ...apiClient.defaults.headers.common,
          "If-None-Match": "",
        },
      }),
  });
};
